import { initializeApp, type FirebaseOptions } from 'firebase/app'
import { getMessaging, getToken, isSupported } from 'firebase/messaging'

/**
 * Firebase options.
 */
export interface Options extends FirebaseOptions {
  /**
   * Voluntary application server identification key
   * used for authorizing backend server to send notifications.
   */
  vapidKey: string
}

/**
 * Firebase client.
 */
export default class Firebase {
  /**
   * Local storage token key.
   */
  public static readonly TOKEN_KEY = 'firebase.token'

  /**
   * Instantiates a new firebase client.
   */
  constructor(
    public options: Options
  ) { }

  /**
   * Synchronously initializes firebase client.
   */
  init () {
    initializeApp(this.options)
  }

  /**
   * Returns firebase messaging token. Asks for notifications permissions
   * if not already set, quits silently if browser not supported.
   */
  async getToken () {
    if (!await isSupported()) {
      return ''
    }
    try {
      const { vapidKey } = this.options
      const token = await getToken(getMessaging(), { vapidKey })
      localStorage.setItem(Firebase.TOKEN_KEY, token)
      return token
    } catch {
      return localStorage.getItem(Firebase.TOKEN_KEY) ?? ''
    }
  }
}
